package com.deange.nastychristmas.ui.compose

import androidx.compose.runtime.Composable

@Composable
actual fun BackHandler(onBack: () -> Unit) {
}
